import { render, staticRenderFns } from "./PrintRemains.vue?vue&type=template&id=1e67541a&lang=pug&"
import script from "./PrintRemains.vue?vue&type=script&lang=js&"
export * from "./PrintRemains.vue?vue&type=script&lang=js&"
import style0 from "./PrintRemains.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports